import React from 'react';
import { Theme, Typography } from '@mui/material';
import { SubMenuContainer, SubMenuItem } from './SubMenu.styles';
import { SubMenuItem as SubMenuItemType } from './LeftSideMenu.types';

interface SubMenuProps {
  subItems: SubMenuItemType[];
  isVisible: boolean;
  theme: Theme;
}

/**
 * Handles submenu rendering and interactions
 */
export const SubMenu: React.FC<SubMenuProps> = ({ subItems, isVisible, theme }) => {
  const handleSubmenuClick = (event: React.MouseEvent<HTMLLIElement>, action: () => void) => {
    event.stopPropagation(); // Prevent parent menu item click
    action();
  };

  return (
    <SubMenuContainer
      theme={theme}
      sx={{
        opacity: isVisible ? 1 : 0,
        visibility: isVisible ? 'visible' : 'hidden',
        transform: isVisible ? 'translateX(0)' : 'translateX(-10px)',
      }}
    >
      {subItems.filter(el=>el.turnedOn).map((subItem, subIndex) => (
        <SubMenuItem
          key={subIndex}
          theme={theme}
          disabled={subItem.disabled}
          onClick={(event) => !subItem.disabled && handleSubmenuClick(event, subItem.action)}
        >
          <Typography variant="body1">{subItem.text}</Typography>
          {subItem.actionIcon}
        </SubMenuItem>
      ))}
    </SubMenuContainer>
  );
};